/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_SelectInputs */

const en_recipes_select = /** @type {(inputs: Recipes_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select`)
};

const de_recipes_select = /** @type {(inputs: Recipes_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswählen`)
};

/**
* | output |
* | --- |
* | "Select" |
*
* @param {Recipes_SelectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_select = /** @type {((inputs?: Recipes_SelectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_SelectInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_select(inputs)
	return en_recipes_select(inputs)
});